module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n  "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Sinarmas Land")]), _vm._v(".")]), _vm._v(" All rights reserved.\n  "), _c('img', {
    staticStyle: {
      "float": "right",
      "height": "30px"
    },
    attrs: {
      "src": "/static/img/logoSML.png",
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-137f7dad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/DashFooter.vue
// module id = 709
// module chunks = 1